import React, { forwardRef } from 'react';
import clsx from 'clsx';
import { Theme } from '@mui/material/styles';
import { withStyles } from 'tss-react/mui';
import EDTypography from '../Typography/EDTypography';

interface IChildProps {
  children?: React.ReactNode;
}

type ChildrenType = Array<React.ReactElement<IChildProps>>;

interface IProps {
  activeItems: number;
  classes?: any;
  children: ChildrenType;
  itemsAfterCollapse?: number;
  itemsBeforeCollapse?: number;
  collapsedIconDisabled?: boolean;
  maxItems?: number;
  className?: string;
  disabled?: boolean;
}

const styles = (theme: Theme) => ({
  /* Styles applied to the root element. */
  root: {},
  /* Styles applied to the ol element. */
  ol: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    padding: 0, // Reset
    margin: 0, // Reset
  },
  /* Styles applied to the li element. */
  li: {
    listStyle: 'none',
    '& button': {
      lineHeight: 1.2,
    },
  },
  lastActive: {
    listStyle: 'none',
    maxWidth: '100%',
    flexGrow: 1,
    '& button': {
      whiteSpace: 'nowrap',
      textAlign: 'left',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
    },
  },
  textDisabled: {
    color: theme.palette.action.disabled,
  },

  /* Styles applied to the separator element. */
  separator: {},
});

/**
 * Breadcrumbs används när man inte är på toppnivån i en rutin, för att ge en fingervisning om var man är och en möjlighet att genom klick snabbt gå upp en eller flera nivåer.
 */
export const EDBreadcrumbsBase: React.FC<React.PropsWithChildren<IProps>> =
  forwardRef<HTMLOListElement, IProps>((props, ref) => {
    const {
      children,
      classes,
      className,
      activeItems,
      itemsBeforeCollapse,
      itemsAfterCollapse,
      maxItems,
      collapsedIconDisabled,
      ...other
    } = props;

    return (
      <EDTypography
        component="div"
        color={'inherit'}
        className={clsx(classes.root, className, {
          [classes.textDisabled]: props.disabled,
        })}
        {...other}
      >
        <ol className={classes.ol} ref={ref}>
          {children}
        </ol>
      </EDTypography>
    );
  });

export const EDBreadcrumbs = withStyles(EDBreadcrumbsBase, styles);
